import { FieldPath, UseFormReturn } from "react-hook-form";

import { SaveIndicator } from "./SaveIndicator";
import { useSaveIndicator } from "@/hooks/useSaveIndicator";
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage,
} from "@/components/ui/form";
import { Input } from "@/components/ui/input";

import { misc } from "@/lib/misc";
import { cn } from "@/lib/utils";

export const AutosaveFormCurrencyInput = <T extends Record<string, unknown>>({
  className,
  fieldName,
  form,
  label,
  onBlur,
  placeholder,
}: {
  className?: string;
  fieldName: FieldPath<T>;
  form: UseFormReturn<T>;
  label: string;
  onBlur: () => Promise<void> | void;
  placeholder?: string;
}) => {
  const { handleChange, status } = useSaveIndicator();

  return (
    <FormField
      control={form.control}
      name={fieldName}
      render={({ field }) => {
        return (
          <FormItem className={cn("text-slate-700", className)}>
            <FormLabel className="inline-flex w-full items-center justify-between">
              {label}
              <SaveIndicator status={status} />
            </FormLabel>
            <FormControl>
              <Input
                {...field}
                className="bg-slate-50 text-black"
                onBlur={() => {
                  field.onBlur();
                  void onBlur();
                }}
                onChange={(e) => {
                  field.onChange(e);
                  handleChange();
                }}
                onKeyDown={misc.enforceCurrencyInput}
                placeholder={placeholder}
                value={(field.value as string | number | null) ?? ""}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        );
      }}
    />
  );
};
